module.exports = __webpack_public_path__ + "media/images/icons/flags/IL-3e8c596d20d3cdb2f051625218c6e824.svg";